/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoTestRegionDTO } from './geoTestRegionDTO';


export interface GeoTestRegionsDataDTO { 
    /**
     * List of selected region configurations with cell assignments and locations
     */
    selectedRegions: Array<GeoTestRegionDTO>;
    /**
     * Test duration in weeks
     */
    testLength: number;
    /**
     * View type for metrics display (ROAS or CPO)
     */
    viewType: GeoTestRegionsDataDTO.ViewTypeEnum;
    /**
     * Target incremental ROAS value for the test
     */
    targetROAS?: number;
    /**
     * Minimum detectable incremental ROAS for the test configuration
     */
    minimumDetectableROAS?: number;
    /**
     * Target cost per order value for the test
     */
    targetCPO?: number;
    /**
     * Minimum detectable cost per order for the test configuration
     */
    minimumDetectableCPO?: number;
    /**
     * Holdout BAU spend override; null uses live default.
     */
    customSpend?: number | null;
    /**
     * Geographic scope IDs defining the test boundary
     */
    geoScopeIds?: Array<number>;
    /**
     * Split type for the test: GEO for geographic or AUDIENCE for audience-based
     */
    splitType?: string;
    /**
     * Geographic granularity level (e.g. DMA, REGION, CITY, ZIP)
     */
    geoSplitLevel?: string;
    /**
     * Filter parameters used during region selection including likelihood to detect lift
     */
    filterParams?: object;
    /**
     * Unique execution ID from the market selection computation that produced these regions
     */
    marketSelectionExecutionId: string;
}
export namespace GeoTestRegionsDataDTO {
    export type ViewTypeEnum = 'ROAS' | 'CPO';
    export const ViewTypeEnum = {
        Roas: 'ROAS' as ViewTypeEnum,
        Cpo: 'CPO' as ViewTypeEnum
    };
}


